import axios from 'axios'
import { tsWhoAmI } from '../../Typescript/API_Response'

const phpClient = (whoAmI?: tsWhoAmI) =>
  (() => {
    return axios.create({
      baseURL: `${['development', 'production', undefined].includes(process.env.REACT_APP_STAGE) ? window.location.origin : 'http://localhost:3000'}`,
      params:
        whoAmI ?
          {
            employeeid: whoAmI.user,
            token: whoAmI.token,
            database: whoAmI.db,
          }
        : {},
      headers: {
        'content-type': 'application/json',
      },
    })
  })()

export default phpClient
